import { datadogRum } from '@datadog/browser-rum';
import { useEffect } from 'react';

import { useConsent } from './useConsent';

/**
 * Datadog RUM starts with tracking consent `not-granted` (see
 * `lib/config/config.ts`). Counsel (2026-10-29) classes RUM as Performance,
 * so it collects only for logged in users and for logged out visitors who
 * allow Performance, and stops if it's withdrawn. Datadog Logs is error
 * reporting and runs without consent.
 */
export const useDatadogTrackingConsent = () => {
  const { performance } = useConsent();

  useEffect(() => {
    datadogRum.setTrackingConsent(performance ? 'granted' : 'not-granted');
  }, [performance]);
};
